module.exports = __webpack_public_path__ + "static/media/smokeExtractor.39886f79.PNG";